import PropTypes from 'prop-types'
import React, { useCallback, useContext } from 'react'
import { useDropzone } from 'react-dropzone'
import { UsuarioContext } from '../context/usuarioContext'
import useError from '../hooks/useError'
import ImagenDni from '../imagen/ImagenDni'
import * as imagenesPerfilService from '../servicios/imagenesPerfilService'

const Upload = ({ idUsuario, accept, idTipo, onCheck, name, errores }) => {
  const { ShowError } = useError(errores, name)
  const { setImagenModif } = useContext(UsuarioContext)

  const upload = async (idUsuario, archivo) => {
    const imagen = new FormData()
    imagen.append('nombre', archivo.name)
    imagen.append('idUsuario', idUsuario)
    imagen.append('archivo', archivo)
    imagen.append('idTipo', idTipo)

    await imagenesPerfilService.subirArchivo(imagen)
    setImagenModif(archivo.lastModified)
    onCheck(idTipo)
  }

  const onDrop = useCallback(
    (acceptedFiles) => {
      acceptedFiles.map((archivo) => {
        upload(idUsuario, archivo).then(() => {})

        return archivo
      })
    },
    [idTipo, idUsuario, upload]
  )

  const { getRootProps, getInputProps } = useDropzone({ onDrop, accept })

  return (
    <>
      <div className="borde-hormiga text-center" {...getRootProps()}>
        <input {...getInputProps()} />
        <div className="row-img-subida contenedor-cont-img-subida-perfil">
          <div className="row">
            <div className="col-6 col-xl-3">
              <div className="row">
                <div className="col-12">
                  <div className="cont-img-subida-perfil">
                    <ImagenDni
                      idUsuario={idUsuario}
                      clase="subida-img"
                      idTipo={idTipo}
                    ></ImagenDni>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {idTipo === 1 ? (
          <p>
            {' '}
            Hacé click para cargar la imagen del frente de tu DNI. Soltala acá ó
            arrastrala desde tu computadora.
          </p>
        ) : (
          <p>
            {' '}
            Hacé click para cargar la imagen del dorso de tu DNI. Soltala acá ó arrastrala
            desde tu computadora.
          </p>
        )}
      </div>
      {<ShowError />}
    </>
  )
}

Upload.propTypes = {
  idUsuario: PropTypes.number.isRequired,
  accept: PropTypes.object.isRequired,
  idTipo: PropTypes.number.isRequired,
  onCheck: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  errores: PropTypes.object
}

export default React.memo(Upload)
